import { createAsyncThunk } from '@reduxjs/toolkit'
import { AxiosClient } from 'src/redux/AxiosClient'

export const sendMailAsync = createAsyncThunk('alix/sendMailAsync', async (payload, toolkit) => {
  return await AxiosClient('POST', `/v1/risk-management/email/send`, payload, toolkit)
})

export const generateContentAIAsync = createAsyncThunk(
  'alix/generateContentAIAsync',
  async (payload, toolkit) => {
    return await AxiosClient(
      'GET',
      `/v1/risk-management/mitigation/generate/email?userName=${payload.userName}&supplierName=${payload.supplierName}&mitigationAction=${payload.mitigationAction}&issues=${payload.issues}&clientId=${payload.clientId}`,
      {},
      toolkit,
    )
  },
)
